import React, { Fragment } from 'react'

import { QUIZ_ATTEMPT_STATUSES } from 'constants/quiz.constants'
import { LESSON_STATUSES_PUBLISH_STATES } from 'constants/courses.constants'

const ICON_CLASS = {
  [QUIZ_ATTEMPT_STATUSES.waiting]: 'fas fa-question-circle',
  [QUIZ_ATTEMPT_STATUSES.failed]: 'fas fa-times-circle',
  [QUIZ_ATTEMPT_STATUSES.completed]: 'fas fa-check-circle',
}

const LessonStatus = ({ lesson, courseViewsStore }) => {
  const { publishState, shouldCompleteQuiz, quizAttempts } = courseViewsStore.getLessonStatus(lesson.id)

  const [lessonIsFinished, lessonIsPublished, lessonIsViewed] = [
    publishState === LESSON_STATUSES_PUBLISH_STATES.finished,
    publishState === LESSON_STATUSES_PUBLISH_STATES.published,
    publishState === LESSON_STATUSES_PUBLISH_STATES.viewed,
  ]

  const lessonIsAvailable = lessonIsFinished || lessonIsPublished || lessonIsViewed

  const quizAttemptStatus = ((quizAttempts || [])[0] || {}).status
  const shouldCompletePrevQuizzes = courseViewsStore.hasRequiredPrevQuizzes(lesson.id)

  return (
    <div className='item-actions'>
      {lessonIsAvailable ? (
        <Fragment>
          {lessonIsFinished ? (
            <Fragment>
              {quizAttemptStatus ? (
                <i className={ICON_CLASS[quizAttemptStatus]} />
              ) : (
                !shouldCompleteQuiz && <i className='fas fa-check-circle' />
              )}
            </Fragment>
          ) : (
            <Fragment>{shouldCompletePrevQuizzes ? <i className='fas fa-lock' /> : ''}</Fragment>
          )}
        </Fragment>
      ) : (
        <i className='fas fa-lock' />
      )}
    </div>
  )
}

export default LessonStatus
